import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0 1rem 0;

  .title {
    opacity: 0.7;
    text-align: center;
    margin-bottom: 2rem !important;
  }
  .logos {
    display: flex;
    justify-content: center;

    img {
      height: 4rem;
      filter: grayscale(100%);
      opacity: 0.5;
      border-radius: 10px;
      &:not(:last-child) {
        margin-right: 2rem;
      }
    }
  }
`;
